/**
 * Capitalise the first letter of the given string.
 */
export function capitalise(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : string;
}
